<template>
    <CRow>
        <CCol col>
            <div class="col-lg-12 control-section" style="padding:10px;position:relative;">
                <div id="cappSpinner"></div>
                <div class="form-row">
                    <div class="form-group col-md-4 ml-5 d-flex justify-content-center input-group">
                        <ejs-dropdownlist ref='dplYears' id="years" name="years" :change='onYearsChange' floatLabelType='Auto' :dataSource='tradingGroupYears' :fields="{text: 'name', value: 'id' }" :index='periodsIndex' placeholder="Years" :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                    <div class="form-group col-md-4 ml-5 d-flex justify-content-center input-group">
                        <ejs-dropdownlist ref='dplPeriods' id='dplPeriods' :dataSource='periods' placeholder='Period' floatLabelType='Auto' :index='periodsIndex' :change='onPeriodsChange' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                    <div class="form-group col-md-4 ml-5 d-flex justify-content-center input-group">
                        <ejs-dropdownlist ref='dplCurrencyCAP' id="currencyCAP" name="currency" v-model="data.currencyId" :change="onCurrencyChangeCAP" :dataSource='currenciesCAP' :fields="{text: 'name', value: 'currencyId' }" placeholder="Currency" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                    <div class="form-group col-md-4 ml-5 d-flex justify-content-center input-group" v-if="showPriceAreaSection">
                        <ejs-dropdownlist ref='dplPriceAreaCost' id="priceAreaCost" name="priceAreaCostName" :enabled="false" :change='onPriceAreaCostChange' floatLabelType='Auto' :index='periodsIndex' :dataSource='priceAreaCost' :fields="{text: 'name', value: 'id' }" placeholder="Price Area:" :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                   
                </div>
                <div class="form-row">
                    <div class="form-group col-md-4 ml-5 d-flex justify-content-center input-group">
                        <ejs-dropdownlist ref='dplGraphTypes' id='dplGraphTypes' :dataSource='graphTypes' placeholder='Type' floatLabelType='Auto' :index='periodsIndex' :change='onGraphChange' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                    <div class="form-group col-md-4 ml-5 d-flex justify-content-center input-group">
                        <ejs-dropdownlist ref='dplPerformanceTypes' id='dplPerformanceTypes' :dataSource='performanceTypes' placeholder='Performance type'floatLabelType='Auto' :index='periodsIndex' :change='onTypeChange' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                    <div>
                        <ejs-checkbox :change="onCheckCostAndPriceDefault" label='Default Mechanism' id="CostAndPriceCheckDefalt" name="CostAndPriceCheckDefalt" floatLabelType='Auto' cssClass="costAndPriceCheck"></ejs-checkbox>
                    </div>
                </div>
                <div class="form-row  justify-content-end ">
                    <ejs-button style="margin-right:10px" cssClass="e-primary" v-on:click.native='download'>Price And Cost Performance Report</ejs-button>
                </div>
                <div v-show="priceViewEnabled">
                    <div v-show="LineGraph" class="bc-white">
                        <ejs-chart id="container" :title='title' :legendSettings="legendSettings" :zoomSettings='zoom' :primaryXAxis='primaryXAxis' :primaryYAxis='primaryYAxis' :tooltip='tooltip' :textRender='textRender' :titleStyle="titleStyle">
                            <e-series-collection>
                                <e-series :dataSource="seriesData" type="Line" xName="periodName" yName="m2m" name="M2M" width="2" :marker="marker" fill="#001c55"></e-series>
                                <e-series :dataSource="seriesData" type="Line" xName="periodName" yName="reference" name="Reference" width="2" :marker="marker" fill="#a35ea1"></e-series>
                            </e-series-collection>
                        </ejs-chart>
                    </div>
                    <div v-show="CandleGraph" class="bc-white">
                        <ejs-chart id="container2" :title='title' :legendSettings="legendSettings" :zoomSettings='zoom' :primaryXAxis='primaryXAxis' :primaryYAxis='primaryYAxis' :tooltip='tooltip' :textRender='textRender' :titleStyle="titleStyle" :tooltipRender='tooltipRenderWhisker'>
                            <e-series-collection>
                                <e-series :dataSource='seriesData' tooltipFormat=' ' type='Candle' xName='periodName' high='highest' low='lowest'
                                          open='firstQuartile' close='thridQuartile' name='Box plot' bearFillColor='#B3edff' bullFillColor='#B3edff' fill="#B3edff" opacity=0.5 :enableSolidCandles='enableSolidCandles' :marker="candleMarker" :border='border'> </e-series>

                                <e-series :dataSource='seriesData' type='Line' xName='periodName' yName='median' name='Median' opacity=0 :marker="medianMarker" fill="#d9853c"> </e-series>
                                <e-series :dataSource="seriesData" type="Line" xName="periodName" yName="m2m" name="M2M" width="2" :marker="marker" fill="#001c55"></e-series>
                                <e-series :dataSource="seriesData" type="Line" xName="periodName" yName="reference" name="Reference" width="2" :marker="marker" fill="#a35ea1"></e-series>
                            </e-series-collection>
                        </ejs-chart>
                    </div>
                    <div v-show="StackedGraph" class="bc-white">
                        <ejs-chart id="container3" :title='title' :legendSettings="legendSettings" :zoomSettings='zoom' :primaryXAxis='primaryXAxis' :primaryYAxis='primaryYAxis' :tooltip='tooltip' :tooltipRender='tooltipRender' :textRender='textRender' :titleStyle="titleStyle"
                                   :palettes="palettes">
                            <e-series-collection>
                                <e-series :dataSource="seriesData" type="StackingColumn" xName="periodName" yName="lowest" name=" " width="2" opacity=0 :marker="marker"></e-series>
                                <e-series :dataSource="seriesData" type="StackingColumn" xName="periodName" yName="medianMin" name="Min-Median" opacity=0.7 width="2" :marker="marker"></e-series>
                                <e-series :dataSource="seriesData" type="StackingColumn" xName="periodName" yName="maxMedian" name="Median-Max" opacity=0.7 width="2" :marker="marker"></e-series>
                                <e-series :dataSource="seriesData" type="StackingLine" xName="periodName" yName="m2m" name="M2M" width="2" :marker="marker"></e-series>
                                <e-series :dataSource="seriesData" type="Line" xName="periodName" yName="reference" name="Reference" width="2" :marker="marker"></e-series>

                            </e-series-collection>
                        </ejs-chart>
                    </div>
                    <ejs-grid ref='grid' :dataSource="gridData" :allowFiltering='false' :allowPaging="true" :allowTextWrap='true' :textWrapSettings='wrapSettings' :allowResizing='true' :query='gridQuery' :allowReordering='true' :allowSorting='true' :toolbar='toolbar' :pageSettings='pageSettings' :actionFailure="actionFailure" :filterSettings='filterOptions'>
                        <e-columns>
                            <e-column field='periodName' headerText='Period' width=120 :isPrimaryKey='true'></e-column>

                            <e-column field='reference' headerText='Reference' textAlign='Right' type="number" format="n3"></e-column>
                            <e-column field='m2m' headerText='Current M2M' textAlign='Right' type="number" format="n3"></e-column>
                            <e-column field='lowest' headerText='Lowest' textAlign='Right' type="number" format="n3"></e-column>
                            <e-column field='firstQuartile' headerText='1st Quartile' textAlign='Right' type="number" format="n3"></e-column>
                            <e-column field='median' headerText='Median' textAlign='Right' type="number" format="n3"></e-column>
                            <e-column field='thridQuartile' headerText='3rd Quartile' textAlign='Right' type="number" format="n3"></e-column>
                            <e-column field='highest' headerText='Highest' textAlign='Right' type="number" format="n3"></e-column>

                            <e-column field='firstQuartileMin' :visible='false'  headerText='1Q-Min' textAlign='Right' type="number" format="n3"></e-column>
                            <e-column field='medianFirstQuartile' :visible='false'  headerText='Median-1Q' textAlign='Right' type="number" format="n3"></e-column>
                            <e-column field='thridQuartileMedian' :visible='false'  headerText='3Q-Median' textAlign='Right' type="number" format="n3"></e-column>
                            <e-column field='highestThridQuartile' :visible='false'  headerText='Max-3Q' textAlign='Right' type="number" format="n3"></e-column>
                            <e-column field='medianMin' :visible='false'  textAlign='Right' headerText='Median-Min' type="number" format="n3"></e-column>
                            <e-column field='maxMedian' :visible='false'  textAlign='Right' headerText='Max-Median' type="number" format="n3"></e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
                <div v-show="costViewEnabled">

                    <div v-show="LineGraph" class="bc-white">
                        <ejs-chart id="containerCost" :title='title' :legendSettings="legendSettings" :zoomSettings='zoom' :primaryXAxis='primaryXAxis' :primaryYAxis='primaryYAxis' :tooltip='tooltip' :textRender='textRender' :titleStyle="titleStyle">
                            <e-series-collection>
                                <e-series :dataSource="seriesDataCost" type="Line" xName="periodName" yName="m2mCost" name="M2M" width="2" :marker="marker" fill="#001c55"></e-series>
                                <e-series :dataSource="seriesDataCost" type="Line" xName="periodName" yName="referenceCost" name="Reference" width="2" :marker="marker" fill="#a35ea1"></e-series>
                            </e-series-collection>
                        </ejs-chart>
                    </div>
                    <div v-show="CandleGraph" class="bc-white">
                        <ejs-chart id="containerCost2" :title='title' :legendSettings="legendSettings" :zoomSettings='zoom' :primaryXAxis='primaryXAxis' :primaryYAxis='primaryYAxis' :tooltip='tooltip' :textRender='textRender' :tooltipRender='tooltipRenderWhisker' :titleStyle="titleStyle">
                            <e-series-collection>
                                <e-series :dataSource='seriesDataCost' tooltipFormat=' ' type='Candle' xName='periodName' high='highestCost' low='lowestCost'
                                          open='firstQuartileCost' close='thridQuartileCost' name='Box plot' bearFillColor='#B3edff' bullFillColor='#B3edff' fill="#B3edff" opacity=0.5 :enableSolidCandles='enableSolidCandles' :marker="candleMarker" :border='border'> </e-series>

                                <e-series :dataSource='seriesDataCost' type='Line' xName='periodName' yName='medianCost' name='Median' opacity=0 :marker="medianMarker" fill="#d9853c"> </e-series>
                                <e-series :dataSource="seriesDataCost" type="Line" xName="periodName" yName="m2mCost" name="M2M" width="2" :marker="marker" fill="#001c55"></e-series>
                                <e-series :dataSource="seriesDataCost" type="Line" xName="periodName" yName="referenceCost" name="Reference" width="2" :marker="marker" fill="#a35ea1"></e-series>
                            </e-series-collection>
                        </ejs-chart>
                    </div>
                    <div v-show="StackedGraph" class="bc-white">
                        <ejs-chart id="containerCost3" :title='title' :legendSettings="legendSettings" :zoomSettings='zoom' :primaryXAxis='primaryXAxis' :primaryYAxis='primaryYAxis' :tooltipRender='tooltipRender' :tooltip='tooltip' :textRender='textRender' :titleStyle="titleStyle"
                                   :palettes="palettes">
                            <e-series-collection>
                                <e-series :dataSource="seriesDataCost" type="StackingColumn" xName="periodName" yName="lowestCost" name=" " width="2" opacity=0 :marker="marker"></e-series>
                                <e-series :dataSource="seriesDataCost" type="StackingColumn" xName="periodName" yName="medianMinCost" name="Min-Median" opacity=0.7 width="2" :marker="marker"></e-series>
                                <e-series :dataSource="seriesDataCost" type="StackingColumn" xName="periodName" yName="maxMedianCost" name="Median-Max" opacity=0.7 width="2" :marker="marker"></e-series>
                                <e-series :dataSource="seriesDataCost" type="StackingLine" xName="periodName" yName="m2mCost" name="M2M" width="2" :marker="marker"></e-series>
                            </e-series-collection>
                        </ejs-chart>
                    </div>
                    <ejs-grid ref='costGrid' :dataSource="gridData" :allowFiltering='false' :allowPaging="true" :allowTextWrap='true' :textWrapSettings='wrapSettings' :allowResizing='true' :query='gridQuery' :allowReordering='true' :allowSorting='true' :toolbar='toolbar' :pageSettings='pageSettings' :actionFailure="actionFailure" :filterSettings='filterOptions'>
                        <e-columns>
                            <e-column field='periodName' headerText='Period' width=120 :isPrimaryKey='true'></e-column>

                            <e-column field='referenceCost' headerText='Reference' textAlign='Right' type="number" format="n0"></e-column>
                            <e-column field='m2mCost' headerText='Current M2M' textAlign='Right' type="number" format="n0"></e-column>
                            <e-column field='lowestCost' headerText='Lowest' textAlign='Right' type="number" format="n0"></e-column>
                            <e-column field='firstQuartileCost' headerText='1st Quartile' textAlign='Right' type="number" format="n0"></e-column>
                            <e-column field='medianCost' headerText='Median' textAlign='Right' type="number" format="n0"></e-column>
                            <e-column field='thridQuartileCost' headerText='3rd Quartile' textAlign='Right' type="number" format="n0"></e-column>
                            <e-column field='highestCost' headerText='Highest' textAlign='Right' type="number" format="n0"></e-column>

                            <e-column field='firstQuartileMinCost' :visible='false' headerText='1Q-Min' textAlign='Right' type="number" format="n0"></e-column>
                            <e-column field='medianFirstQuartileCost' :visible='false'  headerText='Median-1Q' textAlign='Right' type="number" format="n0"></e-column>
                            <e-column field='thridQuartileMedianCost' :visible='false'  headerText='3Q-Median' textAlign='Right' type="number" format="n0"></e-column>
                            <e-column field='highestThridQuartileCost' :visible='false'  headerText='Max-3Q' textAlign='Right' type="number" format="n0"></e-column>
                            <e-column field='medianMinCost' textAlign='Right' :visible='false'  headerText='Median-Min' type="number" format="n0"></e-column>
                            <e-column field='maxMedianCost' textAlign='Right' :visible='false'  headerText='Max-Median' type="number" format="n0"></e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
            </div>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey, CommandColumn } from "@syncfusion/ej2-vue-grids";
    import { DropDownList } from "@syncfusion/ej2-dropdowns";
    import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import SyncHelper from '../../../common/syncfusion';
    import { Query } from '@syncfusion/ej2-data';
    import gridOptions from '../../../common/gridOptions'
    import dates from '../../../common/dates'
    import urls from '../../../common/urls';
    import apis from '../../../common/network'
    import { DatePickerPlugin, DatePicker } from '@syncfusion/ej2-vue-calendars';
    import { CheckBoxPlugin, CheckBox } from "@syncfusion/ej2-vue-buttons";
    import { ChartPlugin, ColumnSeries, StripLine, LineSeries, DataLabel, Category, DateTime, Tooltip, ChartAnnotation, Zoom, MultiColoredLineSeries } from "@syncfusion/ej2-vue-charts";
    import { StackingLineSeries, StackingColumnSeries, ScatterSeries, CandleSeries, Legend } from "@syncfusion/ej2-vue-charts";

    import { DialogPlugin } from '@syncfusion/ej2-vue-popups';
    import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons';
    import { enableRipple } from '@syncfusion/ej2-base';
    import { TextBox } from "@syncfusion/ej2-inputs";
    import store from '../../../store';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';


    Vue.use(ChartPlugin);
    Vue.use(UploaderPlugin);
    Vue.use(DialogUtility);
    Vue.use(GridPlugin);
    Vue.use(CheckBoxPlugin);
    Vue.use(ButtonPlugin);
    Vue.use(DialogPlugin);
    enableRipple(true);
    export default {
        components: {
        },
        data() {
            return {
                // needed because of form being loaded from tab,in such cases this isnt available and store is loaded from import
                store: store,
                palettes: ["#fff", "#1a9470", "#f25c54", "#001c55", "#a35ea1"],
                periodsIndex: 0,
                periodsIndexCurrency: 3,
                performanceTypes: ['Price', 'Cost'],
                graphTypes: ['Line', 'Candle', 'Stacked'],
                periods: ['Month', 'Quarter', 'Season', 'Fiscal', 'Calendar'],
                draggable: true,
                position: { X: 'center', Y: 'center' },
                zoom:
                {
                    enableMouseWheelZooming: true,
                    enablePinchZooming: true,
                    enableSelectionZooming: true
                },
                priceViewEnabled: true,
                costViewEnabled: false,
                LineGraph: true,
                CandleGraph: false,
                StackedGraph: false,
                loadGraphData: null,
                enableSolidCandles: true,
                priceAreaNames: store.state.pricingAreaNames,
                showPriceAreaSection: false,
                tradingGroupId: parseInt(store.state.reportTradingGroupId),
                gridQuery: new Query().addParams("tradingGroupId", store.state.reportTradingGroupId),
                title: "",
                tooltip: { enable: true},
                type: "",
                max: 0,
                min: 0,
                border: { color: "#FF0000", width: 2 },
                wrapSettings: { wrapMode: 'Header' },
                gridData: null,
                seriesData: null,
                seriesDataCost : null,
                pageSettings: gridOptions.pageSettings,
                toolbar: [],
                requiredRules: { required: true },
                percentageRules: { required: true, number: true },
                nameRules: { required: true, maxLength: 50 },
                editparams: { params: { popupHeight: '300px' } },
                filterOptions: gridOptions.filterSettings,
                primaryXAxis: {
                    valueType: 'Category',
                    title: '',
                    labelStyle: { fontFamily: 'Segoe UI', fontStyle: 'normal', fontSize: '14px', fontWeight: 'normal', textAnchor: 'middle', color: '#8a93a2' }
                },
                legendSettings: {
                    textStyle: { fontFamily: 'Segoe UI', fontStyle: 'normal', fontSize: '13px', fontWeight: 'normal', textAnchor: 'middle', color: '#8a93a2' }
                },
                primaryYAxis:
                {
                    title: 'Price',
                    titleStyle: { fontFamily: 'Segoe UI', fontStyle: 'normal', fontSize: '14px', fontWeight: 'normal', textAnchor: 'middle', color: '#8a93a2' },
                    labelStyle: { fontFamily: 'Segoe UI', fontStyle: 'normal', fontSize: '14px', fontWeight: 'normal', textAnchor: 'middle', color: '#8a93a2' }
                },
                titleStyle: {
                    fontFamily: "Arial",
                    fontStyle: 'italic',
                    fontWeight: 'regular',
                    color: "#E27F2D",
                    size: '23px'
                },
                title: this.title,
                medianMarker: { visible: true, shape: 'HorizontalLine', dataLabel: { visible: true } },
                candleMarker: { dataLabel: { visible: false } },
                marker: { visible: true, dataLabel: { visible: true } },
                type: 'Price',
                allowFiltering: true,
                currencyId: null
            };
        },
        methods: {

            onPriceAreaCostChange: function (args) {
                let currencyId = this.$refs.dplCurrencyCAP.ej2Instances.value;
                let year = document.getElementById('years').value;
                let performanceType = document.getElementById('dplPerformanceTypes').value;
                if (args.isInteracted) {
                    this.loadGraph(year, currencyId, performanceType, args.itemData.id, false);
                }
            },
            onCheckPASystemCost(args) {
                let pricingAreaId = document.getElementById('priceAreaCost') == null ? undefined : document.getElementById('priceAreaCost').ej2_instances[0].value;
                let currencyId = this.$refs.dplCurrencyCAP.ej2Instances.value;
                let year = document.getElementById('years').value;
                let performanceType = document.getElementById('dplPerformanceTypes').value;
                if (args.checked) {
                    this.loadGraph(year, currencyId, performanceType, pricingAreaId, true);
                } else {
                    this.loadGraph(year, currencyId, performanceType, pricingAreaId, false);
                }
            },
            tooltipRender: function (args) {
                
                var pointData = this.seriesData.filter(tp => { return tp.periodName === args.data.pointX })[0];
                var median = this.type == 'Cost' ? pointData.medianCost : pointData.median;
                if (args.data.seriesName == "Median-Max") {

                    var max = this.type == 'Cost' ? pointData.highestCost : pointData.highest;
                    args.text = "Median: " + median + "<br> Max: " + max;
                }
                else if (args.data.seriesName == "Min-Median"){
                    var min = this.type == 'Cost' ? pointData.lowestCost : pointData.lowest;
                    args.text = "Median: " + median + "<br> Min: " + min ;
                }
        

            },
            tooltipRenderWhisker: function (args) {
                if (args.data.seriesName == "Box plot") {
                    var pointData = this.seriesData.filter(tp => { return tp.periodName === args.data.pointX })[0];
                    var max = this.type == 'Cost' ? pointData.highestCost : pointData.highest;
                    var min = this.type == 'Cost' ? pointData.lowestCost : pointData.lowest;
                    var firstQ = this.type == 'Cost' ? pointData.firstQuartileCost : pointData.firstQuartile;
                    var thirdQ = this.type == 'Cost' ? pointData.thridQuartileCost : pointData.thridQuartile;
                    args.text = "Min: " + min + "<br> 1Q: " + firstQ + "<br> 3Q: " + thirdQ + "<br> Max: " + max;
                }
            },
            onCheckCostAndPriceDefault(args) {
                let pricingAreaId = document.getElementById('priceAreaCost') == null ? undefined : document.getElementById('priceAreaCost').ej2_instances[0].value;
                store.state.isCheckDefaultM = args.checked;
                let currencyId = this.$refs.dplCurrencyCAP.ej2Instances.value;
                let year = document.getElementById('years').value;
                let performanceType = document.getElementById('dplPerformanceTypes').value;
                this.loadGraph(year, currencyId, performanceType, pricingAreaId, false);
            },
            onYearsChange: function (e) {
                this.loadGraph(e.value);
            },
            onPeriodsChange: function (e) {
                let pricingAreaId = document.getElementById('priceAreaCost') == null ? undefined : document.getElementById('priceAreaCost').ej2_instances[0].value;
                let currencyId = this.$refs.dplCurrencyCAP.ej2Instances.value;
                let year = document.getElementById('years').value;
                let performanceType = document.getElementById('dplPerformanceTypes').value;
                this.loadGraph(year, currencyId, performanceType, pricingAreaId, false);
                this.updateGraph();
            },
            onTypeChange: function (e) {
                this.type = e.value;
                let pricingAreaId = document.getElementById('priceAreaCost') == null ? undefined : document.getElementById('priceAreaCost').ej2_instances[0].value;
                let currencyId = this.$refs.dplCurrencyCAP.ej2Instances.value;
                let year = document.getElementById('years').value;

                this.loadGraph(year, currencyId, this.type, pricingAreaId, false);
                this.updateGraph();
            },
            onGraphChange: function (e) {
                this.updateGraphTpeToShow(e.value);
            },
            textRender: function (args) {
                args.text = "";
            },
            onCurrencyChangeCAP: function (args) {

                let pricingAreaId = document.getElementById('priceAreaCost') == null ? undefined : document.getElementById('priceAreaCost').ej2_instances[0].value;
                this.currencyId = args.itemData.currencyId;
                let year = document.getElementById('years').value;
                let performanceType = document.getElementById('dplPerformanceTypes').value;

                this.loadGraph(year, this.currencyId, performanceType, pricingAreaId, false);

            },
            loadGraph: function (year, currencyId, type, pricingAreaId, priceSystemArea) {
                showSpinner(document.getElementById('cappSpinner'));
                showSpinner(document.getElementById('mainSpinner'));
                apis.protectedApi(`Report/GetPricePerformanceForTradingGroup?tradingGroupId=${this.tradingGroupId}&year=${year}&currencyId=${currencyId == undefined ? "" : currencyId}&performanceType=${type}
                &pricingAreaId=${pricingAreaId == undefined ? "" : pricingAreaId}&priceSystemArea=${priceSystemArea == undefined ? false : priceSystemArea} `).then(it => {
                    this.loadGraphData = it.data;
                    console.log(it.data);
                    this.updateGraph();

                    if (it.data.value == 'p/therm') {

                        this.$refs.dplCurrencyCAP.ej2Instances.text = "p - GBp";

                    } else {

                        this.$refs.dplCurrencyCAP.ej2Instances.text = it.data.currencySymbolAndName;
                    }
                    hideSpinner(document.getElementById('cappSpinner'));
                    hideSpinner(document.getElementById('mainSpinner'));
                })
                    .catch(
                        response => {
                            hideSpinner(document.getElementById('cappSpinner'));
                            hideSpinner(document.getElementById('mainSpinner'));
                            var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                            gridOptions.errorAlert("Error: " + message);
                        }
                    );
            },
            updateGraph: function () {
                if (this.loadGraphData != null) {
                    var chart, chart2, chart3;
                    var title = "";
                    var type = this.$refs.dplPerformanceTypes.ej2Instances.value;
                    if (type == 'Cost') {
                        title = type + ' ' + this.loadGraphData.currency;
                        this.seriesDataCost = this.getSeriesData();
                        this.gridData = this.getSeriesData();
                        this.costViewEnabled = true;
                        this.priceViewEnabled = false;
                        chart = document.getElementById('containerCost').ej2_instances[0];
                        chart2 = document.getElementById('containerCost2').ej2_instances[0];
                        chart3 = document.getElementById('containerCost3').ej2_instances[0];

                        this.$refs.costGrid.refresh();
                    } else {
                        title = type + ' ' + this.loadGraphData.value;
                        this.seriesData = this.getSeriesData();
                        this.gridData = this.getSeriesData();
                        this.costViewEnabled = false;
                        this.priceViewEnabled = true;
                        chart = document.getElementById('container').ej2_instances[0];
                        chart2 = document.getElementById('container2').ej2_instances[0];
                        chart3 = document.getElementById('container3').ej2_instances[0];

                        this.$refs.grid.refresh();

                    }

                    chart.primaryYAxis =
                    {
                        title: title
                    };
                    chart2.primaryYAxis = chart.primaryYAxis;
                    chart3.primaryYAxis = chart.primaryYAxis;

                    chart.refresh();
                    chart2.refresh();
                   chart3.refresh();
                }
            },
            getSeriesData: function () {
                var seriesData;
                var period = this.$refs.dplPeriods.ej2Instances.value;
                if (period == "Month") {
                    seriesData = this.loadGraphData.result.month;
                } else if (period == "Quarter") {
                    seriesData = this.loadGraphData.result.quarter;
                } else if (period == "Season") {
                    seriesData = this.loadGraphData.result.season;
                } else if (period == "Calendar") {
                    seriesData = this.loadGraphData.result.calendar;
                } else {
                    seriesData = this.loadGraphData.result.fiscal;
                }
                return seriesData;
            },
            updateGraphTpeToShow: function (type) {
                if (type == 'Line') {
                    this.LineGraph = true;
                    this.CandleGraph = false;
                    this.StackedGraph = false;
                } else if (type == 'Candle') {
                    this.LineGraph = false;
                    this.CandleGraph = true;
                    this.StackedGraph = false;
                } else {
                    this.LineGraph = false;
                    this.CandleGraph = false;
                    this.StackedGraph = true;
                }
            },
            download: function (args) {
                showSpinner(document.getElementById('cappSpinner'));
                showSpinner(document.getElementById('mainSpinner'));

                apis.protectedApi(`${urls.apiBaseUrl}ReportTemplate/generateTradingGroupPriceAndCostReportPage/${this.tradingGroupId}?currencyId=${this.currencyId == undefined ? "" : this.currencyId}&performanceType=${this.type}`).then(it => {
                    window.open(it.data.reportUri);
                    hideSpinner(document.getElementById('cappSpinner'));
                    hideSpinner(document.getElementById('mainSpinner'));
                }
                ).catch(
                    response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                        hideSpinner(document.getElementById('mainSpinner'));
                    }
                );
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            },

        }, mounted: function () {
            createSpinner({
                target: document.getElementById('cappSpinner')
            });
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loading'
            });
            this.loadGraph();
        }, computed: {
            tradingGroupYears() {
                return SyncHelper.getDataManager("utils/tradingGroupYears?tradingGroupId=" + store.state.reportTradingGroupId);
            },
            currenciesCAP() {
               
                return SyncHelper.getDataManager("utils/currenciesAvailable?tradingGroupId=" + store.state.reportTradingGroupId);
            },
            priceAreaCost() {
                return SyncHelper.getDataManager("utils/pricingContractAreas?tradingGroupId=" + store.state.reportTradingGroupId);
            }
        }, updated: function () {
            this.$nextTick(() => {
                window.dispatchEvent(new Event('resize'));
            });
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey, CommandColumn],
            chart: [ColumnSeries, StripLine, LineSeries, Category, DataLabel, DateTime, Tooltip, ChartAnnotation, ScatterSeries, StackingColumnSeries, CandleSeries, Zoom, MultiColoredLineSeries, StackingLineSeries, Legend]
        }
    };

</script>
<style>
    #container {
        height: 350px;
    }
    .costAndPriceCheck {
        margin: 32px 0px 0px 0px;
    }
    .bc-white{
        background-color:#FFFFFF;
    }
    #cappSpinner {
        display: none;
    }
</style>
